export * from "./ProductHeading";
